import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom"; // Para la redirección
import {
  useUser,
  fetchWithAuth,
  fetchWithAuthUpload,
  createSlug,
} from "../../Context/UserContext"; // Importar el contexto del usuario
import ModalPreguntar from "./Postular/ModalPreguntar"; // Ajusta la ruta según tu estructura de carpetas
import ModalPostular1 from "./Postular/ModalPostular1";
import ModalPostular2 from "./Postular/ModalPostular2"; // Asegúrate de usar la ruta correcta
import { format } from "date-fns";
import { es } from "date-fns/locale";
import companyData from "../../Data/CompanyData";
import categories from "../../Data/Categories";
import Contacto from "../../Contacto/Contacto"; // Importa el componente de contacto
import API_URL from "../../config";
import AccionesPregunta from "../AdminLicitacion/Botones/AccionesPregunta"; // Importar AccionesPregunta
import { LoadingOverlay } from "../../components/ui/loading-overlay";
import { Share2, FileText } from "lucide-react";
import { Button } from "../../components/ui/button";
import { cn } from "../../lib/utils";
import { toast } from "sonner";

const formatDate = (dateString) => {
  try {
    const date = new Date(dateString); // Convierte la cadena en un objeto Date
    return format(date, "PPPP p", { locale: es }); // Formatea la fecha
  } catch {
    return "Fecha inválida"; // Maneja errores si el formato no es válido
  }
};

const InfoLicitaciones = ({ tenders = [], page, totalPages, setPage }) => {
  // Crear un estado local basado en los `tenders` que recibe como prop
  const [localTenders, setLocalTenders] = useState(tenders);
  const [selectedTender, setSelectedTender] = useState(null);
  const [showDetails, setShowDetails] = useState(false); // Controla si se muestran los detalles (mobile)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768); // Detecta si es mobile
  const { user } = useUser(); // Accede al contexto del usuario
  const navigate = useNavigate(); // Hook para redirigir al usuario
  const [showPreguntarModal, setShowPreguntarModal] = useState(false);
  const [questionAdded, setQuestionAdded] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [showModal1, setShowModal1] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [isOwner, setIsOwner] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // Estado de carga
  const [formData, setFormData] = useState({
    propuesta: "",
    archivosAdjuntos: [],
    adjuntosPreguntas: {}, // Nuevo estado para los archivos de preguntas
    respuestas: {},
  });

  const handleOpenModal1 = () => {
    if (user) {
      setShowModal1(true);
    } else {
      toast.error("Debes iniciar sesión para postular.");
      navigate("/login");
    }
  };
  const handleCloseModal1 = () => setShowModal1(false);
  const handleCloseModal2 = () => setShowModal2(false);

  const categoryIcons = [
    ...categories.filter((cat) => cat.label !== "Otro Servicio"),
    ...companyData.sectores,
  ].reduce((acc, item) => {
    acc[item.label] = item.icon;
    return acc;
  }, {});

  useEffect(() => {
    setIsOwner(user?.user?.id_user === selectedTender?.id_user);
  }, [user, selectedTender]);

  // Sincronizar `tenders` si cambian externamente
  useEffect(() => {
    setLocalTenders(tenders);
  }, [tenders]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize(); // Verifica el tamaño inicial
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []); // Sin dependencias, se ejecuta solo al montar/desmontar

  useEffect(() => {
    if (questionAdded) {
      // Desplazarse al final de la página
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: "smooth",
      });

      // Restablecer la bandera
      setQuestionAdded(false);
    } else {
      // Lógica normal de selección de tender
      if (localTenders.length === 0) {
        setSelectedTender(null);
      } else if (!isMobile && localTenders.length > 0) {
        setSelectedTender(localTenders[0]);
        setShowDetails(false);
      } else if (isMobile) {
        setSelectedTender(null);
      }
    }
  }, [isMobile, localTenders]);

  const handleNextFromModal1 = () => {
    setFormData((prev) => ({
      ...prev,
      propuesta: formData.propuesta || prev.propuesta,
      archivosAdjuntos: [...new Set([...(formData.archivosAdjuntos || [])])], // ✅ Eliminar duplicados
    }));
    setShowModal1(false);
    setShowModal2(true);
  };

  const onBack = () => {
    setFormData((prev) => ({
      ...prev,
      respuestas: { ...prev.respuestas, ...formData.respuestas }, // ✅ Mantener respuestas previas y nuevas
      adjuntosPreguntas: {
        ...prev.adjuntosPreguntas,
        ...formData.adjuntosPreguntas,
      }, // ✅ Mantener archivos de preguntas previos y nuevos
    }));
    setShowModal2(false);
    setShowModal1(true);
  };

  const handleSubmitPostulation = async () => {
    setIsLoading(true); // ✅ Mostrar el indicador de carga
    console.log("Enviando postulación:", formData);

    const id_tender = selectedTender.id_tender; // ID de la licitación

    const payload = {
      ...formData,
      tender_id: selectedTender.id_tender,
    };

    try {
      const response = await fetchWithAuth(
        `${API_URL}/licit/create_application`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Error al crear la postulación");
      }

      const postulationData = await response.json();
      const id_application = postulationData?.id_application;

      if (!id_application) {
        throw new Error("No se recibió un ID de postulación válido."); // ✅ Detener ejecución si no hay ID
      }

      // ✅ 2. Subir archivos generales a S3
      if (formData.archivosAdjuntos?.length > 0) {
        await Promise.all(
          formData.archivosAdjuntos.map(async (file) => {
            if (!(file instanceof File)) return null;

            console.log("file", file);

            const fileData = new FormData();
            fileData.append("file", file);
            fileData.append("id_tender", id_tender);
            fileData.append("id_application", id_application);

            console.log("fileData antes de enviar:");
            for (let pair of fileData.entries()) {
              console.log(`${pair[0]}:`, pair[1]); // Muestra las claves y valores en FormData
            }

            const uploadResponse = await fetchWithAuthUpload(
              `${API_URL}/upload/upload-application-file`,
              { method: "POST", body: fileData }
            );

            if (!uploadResponse.ok) {
              console.error(
                `❌ Error al subir archivo:`,
                await uploadResponse.text()
              );
              throw new Error("Error al subir archivo");
            }
          })
        );
      }

      // ✅ 2. Subir archivos de respuestas de preguntas a S3
      if (Object.keys(formData.adjuntosPreguntas || {}).length > 0) {
        await Promise.all(
          Object.entries(formData.adjuntosPreguntas).map(
            async ([pregunta, data]) => {
              const archivos = data.archivos || [];
              await Promise.all(
                archivos.map(async (file) => {
                  if (!(file instanceof File)) return null;

                  const fileData = new FormData();
                  fileData.append("file", file);
                  fileData.append("id_tender", id_tender);
                  fileData.append("id_application", id_application);
                  fileData.append("id_pregunta", pregunta); // ✅ Asociar con la pregunta

                  console.log("fileData", fileData);

                  const uploadResponse = await fetchWithAuthUpload(
                    `${API_URL}/upload/upload-question-file`,
                    { method: "POST", body: fileData }
                  );

                  if (!uploadResponse.ok) {
                    console.error(
                      `❌ Error al subir archivo de pregunta:`,
                      await uploadResponse.text()
                    );
                    throw new Error("Error al subir archivo de pregunta");
                  }
                })
              );
            }
          )
        );
      }

      // ✅ Éxito
      toast.success("Postulación enviada con éxito");
      setShowModal2(false);
      navigate("/mis-postulaciones"); // Redirige a la página de postulaciones
    } catch (error) {
      console.error("Error al enviar la postulación:", error);
      toast.error("Error al enviar la postulación");
    } finally {
      setIsLoading(false); // ✅ Ocultar el indicador de carga
    }
  };

  const handleOpenPreguntarModal = () => {
    if (user && selectedTender) {
      setShowPreguntarModal(true);
    } else {
      toast.error("Debes iniciar sesión para preguntar.");
      navigate("/login"); // Redirige al login si no está logueado
    }
  };

  const handleClosePreguntarModal = () => setShowPreguntarModal(false);

  const handleSubmitQuestion = async (question) => {
    try {
      const response = await fetchWithAuth(
        `${API_URL}/licit/add_question/${selectedTender.id_tender}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ question }),
        }
      );

      if (response.ok) {
        const { question: newQuestion } = await response.json(); // Nueva pregunta del backend

        // Actualizar el estado de selectedTender
        const updatedTender = {
          ...selectedTender,
          questions: [...(selectedTender.questions || []), newQuestion], // Agregar nueva pregunta
        };

        setSelectedTender(updatedTender); // Actualizar la licitación seleccionada localmente

        // Actualizar localTenders con la nueva información
        setLocalTenders((prevTenders) =>
          prevTenders.map((tender) =>
            tender.id_tender === updatedTender.id_tender
              ? updatedTender
              : tender
          )
        );

        // Establecer la bandera de pregunta añadida
        setQuestionAdded(true);

        // Mensaje de éxito
        toast.success("Pregunta añadida correctamente.");
      } else {
        const errorText = await response.text();
        console.error("Error del servidor:", errorText);
        toast.error("Error al enviar la pregunta.");
      }
    } catch (error) {
      console.error("Error al enviar la pregunta:", error.message);
      toast.error("Ocurrió un error al enviar la pregunta.");
    }
  };

  const handleDeleteQuestionFromBackend = async (id_qa) => {
    try {
      const response = await fetchWithAuth(
        `${API_URL}/licit/delete_question/${id_qa}`,
        {
          method: "DELETE",
        }
      );

      if (response.ok) {
        setSelectedTender((prevTender) => ({
          ...prevTender,
          questions: prevTender.questions.filter((q) => q.id_qa !== id_qa),
        }));

        setLocalTenders((prevTenders) =>
          prevTenders.map((tender) =>
            tender.id_tender === selectedTender.id_tender
              ? {
                  ...tender,
                  questions: tender.questions.filter((q) => q.id_qa !== id_qa),
                }
              : tender
          )
        );

        toast.success("Pregunta eliminada correctamente.");
      } else {
        toast.error("Error al eliminar la pregunta.");
      }
    } catch (error) {
      console.error("Error al eliminar la pregunta:", error.message);
      toast.error("Ocurrió un error al eliminar la pregunta.");
    }
  };

  const handleDeleteQuestion = (id_qa) => {
    handleDeleteQuestionFromBackend(id_qa); // Llama al backend y actualiza el estado local
  };

  const handleReplySuccess = (updatedQuestion) => {
    setSelectedTender((prevTender) => ({
      ...prevTender,
      questions: prevTender.questions.map((q) =>
        q.id_qa === updatedQuestion.id_qa ? updatedQuestion : q
      ),
    }));

    setLocalTenders((prevTenders) =>
      prevTenders.map((tender) =>
        tender.id_tender === selectedTender.id_tender
          ? {
              ...tender,
              questions: tender.questions.map((q) =>
                q.id_qa === updatedQuestion.id_qa ? updatedQuestion : q
              ),
            }
          : tender
      )
    );
  };

  // Funciones para manejar la paginación
  const handleNextPage = () => {
    if (page < totalPages) setPage(page + 1);
  };

  const handlePreviousPage = () => {
    if (page > 1) setPage(page - 1);
  };

  const renderPaginationButtons = () => {
    const pages = [];

    if (page > 1) {
      pages.push(page - 1);
    }

    pages.push(page);

    if (page < totalPages) {
      pages.push(page + 1);
    }

    return pages;
  };

  const handleSelectTender = (tender) => {
    setSelectedTender(tender);
    if (isMobile) setShowDetails(true); // Muestra los detalles en mobile
  };

  const handleBackToMenu = () => {
    if (isMobile) setShowDetails(false); // Regresa al menú en mobile
  };

  // utils.js o dentro de InfoLicitaciones.js
  const downloadFile = async (fileId) => {
    try {
      // ✅ Hacer la solicitud para obtener la URL de descarga usando fetchWithAuthUpload
      const response = await fetchWithAuthUpload(
        `${API_URL}/upload/download-file/${fileId}`,
        {
          method: "GET",
        }
      );

      if (!response.ok) {
        throw new Error("Error al obtener el archivo");
      }

      const data = await response.json();

      // ✅ Abrir la URL presignada en una nueva pestaña
      window.open(data.file_url, "_blank");
    } catch (error) {
      console.error("Error al descargar archivo:", error);
    }
  };

  // Bloque de info principal (título, categoría, creador, fechas) — compartido entre mobile/desktop
  const renderHeaderInfo = () => (
    <>
      <h3 className="text-xl font-semibold text-foreground">
        <Link
          to={`/ver-licitacion/${selectedTender.id_tender}/${createSlug(selectedTender.titulo)}`}
          className="hover:text-primary"
        >
          {selectedTender.titulo}
        </Link>
      </h3>
      <p className="text-sm text-muted-foreground">
        <strong className="text-foreground">Categoría:</strong> {selectedTender.categoria}
      </p>
      <p className="text-sm text-muted-foreground">
        <strong className="text-foreground">Creador de la licitación:</strong>{" "}
        {selectedTender.company_name ? (
          <Link
            to={`/company-profile/${selectedTender.id_company}/${selectedTender.company_name}`}
            className="text-primary hover:underline"
          >
            {selectedTender.company_name}
          </Link>
        ) : (
          <Link
            to={`/profile/${selectedTender.id_user}/${selectedTender.user_name}-${selectedTender.user_lastname}`}
            className="text-primary hover:underline"
          >
            {selectedTender.user_name} {selectedTender.user_lastname}
          </Link>
        )}
      </p>
      <p className="text-sm text-muted-foreground">
        <strong className="text-foreground">Creado:</strong> {formatDate(selectedTender.updated_at)}
      </p>
      <p className="text-sm text-muted-foreground">
        <strong className="text-foreground">Fecha máx de postulación:</strong>{" "}
        {formatDate(selectedTender.fecha_maxima_postulacion)}
      </p>
    </>
  );

  // Cuerpo del detalle (descripción, archivos, info extra, preguntas) — compartido entre mobile/desktop
  const renderDetailBody = () => (
    <>
      <div>
        <h3 className="font-semibold text-foreground">Detalles de la licitación:</h3>
        <p className="mt-1 text-sm text-muted-foreground">
          <strong className="text-foreground">Descripción:</strong>{" "}
          <span
            dangerouslySetInnerHTML={{
              __html: (selectedTender.descripcion || "").replace(/\n/g, "<br>"),
            }}
          />
        </p>
      </div>

      {selectedTender.files?.length > 0 && (
        <div>
          <strong className="text-sm text-foreground">Archivos adjuntos:</strong>
          <ul className="mt-1 space-y-1">
            {selectedTender.files.map((file, index) => (
              <li key={index}>
                <button
                  onClick={() => downloadFile(file.id_file)}
                  className="flex items-center gap-1.5 text-sm text-primary hover:underline"
                >
                  <FileText className="h-4 w-4" /> {file.file_name || `Archivo ${index + 1}`}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}

      <div>
        <h3 className="font-semibold text-foreground">Información extra:</h3>
        <ul className="mt-1 space-y-1 text-sm text-muted-foreground">
          <li>
            <strong className="text-foreground">Condiciones de pago:</strong>{" "}
            {Array.isArray(selectedTender.condiciones_pago)
              ? selectedTender.condiciones_pago.join(", ")
              : "No especificado"}
          </li>
          <li>
            <strong className="text-foreground">Ciudades del servicio:</strong>{" "}
            {Array.isArray(selectedTender.ciudad) ? selectedTender.ciudad.join(", ") : "No especificado"}
          </li>
          <li>
            <strong className="text-foreground">Duración del contrato:</strong>{" "}
            {Array.isArray(selectedTender.duracion_contrato)
              ? selectedTender.duracion_contrato.join(", ")
              : "No especificado"}
          </li>
        </ul>
      </div>

      <div>
        <h3 className="font-semibold text-foreground">Preguntas y respuestas:</h3>
        {selectedTender.questions?.length > 0 ? (
          <div className="mt-2 space-y-4">
            {selectedTender.questions.map((questionObj, index) => (
              <div
                key={index}
                id={`question-${questionObj.id_qa}`}
                className="rounded-md border border-border p-3 text-sm"
              >
                <p>
                  <strong className="text-foreground">Usuario:</strong>{" "}
                  <Link
                    to={`/profile/${questionObj.id_user}/${questionObj.nombre_usuario}-${questionObj.apellido_usuario}`}
                    className="text-primary hover:underline"
                  >
                    {`${questionObj.nombre_usuario || "Desconocido"} ${questionObj.apellido_usuario || ""}`}
                  </Link>
                </p>
                <p className="mt-1">
                  <strong className="text-foreground">Pregunta {index + 1}:</strong>{" "}
                  {questionObj.pregunta || "Pregunta no disponible"}
                </p>
                <p className="mt-1">
                  <strong className="text-foreground">Respuesta:</strong> {questionObj.respuesta || "-"}
                </p>
                {isOwner && (
                  <AccionesPregunta
                    pregunta={questionObj}
                    onDelete={handleDeleteQuestion}
                    onReplySuccess={handleReplySuccess}
                  />
                )}
              </div>
            ))}
          </div>
        ) : (
          <p className="mt-1 text-sm text-muted-foreground">No hay preguntas asociadas a esta licitación.</p>
        )}
      </div>
    </>
  );

  const puedePostular =
    !isOwner && new Date(selectedTender?.fecha_maxima_postulacion) >= new Date();

  return (
    <div className="flex flex-col gap-6 lg:flex-row">
      {isLoading && <LoadingOverlay />}
      {/* Menú izquierdo */}
      {!showDetails && (
        <div className="w-full lg:w-80 lg:shrink-0">
          {localTenders.length > 0 ? (
            <>
              <div className="flex flex-col gap-2">
                {tenders.map((tender) => (
                  <button
                    key={tender.id_tender}
                    onClick={() => handleSelectTender(tender)}
                    className={cn(
                      "flex items-start gap-3 rounded-lg border border-border p-3 text-left hover:bg-muted",
                      selectedTender?.id_tender === tender.id_tender && "border-primary bg-primary/5"
                    )}
                  >
                    <span className="text-xl">{categoryIcons[tender.categoria] || "❓"}</span>

                    <div className="min-w-0 flex-1">
                      <h4 className="text-sm font-semibold text-foreground">
                        {tender.titulo.length > 40 ? `${tender.titulo.slice(0, 40)}...` : tender.titulo}
                      </h4>
                      <p className="truncate text-xs text-muted-foreground">
                        {tender.company_name
                          ? tender.company_name.length > 40
                            ? `${tender.company_name.slice(0, 40)}...`
                            : tender.company_name
                          : `${tender.user_name} ${tender.user_lastname}`.length > 40
                          ? `${`${tender.user_name} ${tender.user_lastname}`.slice(0, 40)}...`
                          : `${tender.user_name} ${tender.user_lastname}`}
                      </p>
                      <p className="truncate text-xs text-muted-foreground">
                        {tender.ciudad && tender.ciudad.length > 0
                          ? tender.ciudad.slice(0, 2).join(", ") + (tender.ciudad.length > 2 ? ", ..." : "")
                          : "Sin ciudades"}
                      </p>
                      <p className="text-xs font-medium text-primary">{tender.categoria}</p>
                    </div>
                  </button>
                ))}
              </div>

              {/* Barra de paginación */}
              <div className="mt-4 flex items-center justify-center gap-2">
                <Button variant="outline" size="sm" onClick={handlePreviousPage} disabled={page === 1}>
                  Atrás
                </Button>
                {renderPaginationButtons().map((p, index) =>
                  p === "..." ? (
                    <span key={index} className="text-muted-foreground">
                      ...
                    </span>
                  ) : (
                    <Button
                      key={p}
                      variant={p === page ? "default" : "outline"}
                      size="sm"
                      onClick={() => setPage(p)}
                    >
                      {p}
                    </Button>
                  )
                )}
                <Button variant="outline" size="sm" onClick={handleNextPage} disabled={page === totalPages}>
                  Siguiente
                </Button>
              </div>
            </>
          ) : (
            <p className="text-muted-foreground">No hay licitaciones. Limpia los filtros para ver más.</p>
          )}
        </div>
      )}

      {/* Detalle a la derecha */}
      {selectedTender && showDetails && isMobile ? (
        <div className="flex-1 space-y-6">
          <div className="space-y-2 border-b border-border pb-4">
            {renderHeaderInfo()}
            <button
              onClick={() => setShowShareModal(true)}
              className="mt-2 flex items-center gap-1.5 text-sm text-primary hover:underline"
            >
              <Share2 className="h-4 w-4" /> Compartir
            </button>
          </div>

          {renderDetailBody()}

          <div className="flex flex-wrap gap-2 border-t border-border pt-4">
            {!isOwner && (
              <>
                {puedePostular && <Button onClick={handleOpenModal1}>Postular</Button>}
                <Button variant="outline" onClick={handleOpenPreguntarModal}>
                  Preguntar
                </Button>
              </>
            )}
            <Button variant="ghost" onClick={handleBackToMenu}>
              ⬅ Volver
            </Button>
          </div>
        </div>
      ) : !isMobile && !selectedTender ? (
        <div className="flex-1 rounded-lg border border-dashed border-border p-10 text-center text-muted-foreground lg:self-start">
          Sin resultados. Limpia los filtros.
        </div>
      ) : (
        !isMobile &&
        selectedTender && (
          <div className="flex-1 space-y-6 lg:sticky lg:top-20 lg:max-h-[calc(100vh-6rem)] lg:self-start lg:overflow-y-auto">
            <div className="space-y-2 border-b border-border pb-4">
              {renderHeaderInfo()}
              <div className="flex flex-wrap items-center gap-2 pt-2">
                {!isOwner && (
                  <>
                    {puedePostular && <Button onClick={handleOpenModal1}>Postular</Button>}
                    <Button variant="outline" onClick={handleOpenPreguntarModal}>
                      Preguntar
                    </Button>
                  </>
                )}
                <Button variant="ghost" onClick={() => setShowShareModal(true)}>
                  <Share2 className="h-4 w-4" /> Compartir
                </Button>
              </div>
            </div>

            {renderDetailBody()}
          </div>
        )
      )}

      {/* Modal Preguntar */}
      {showPreguntarModal && (
        <ModalPreguntar
          show={showPreguntarModal}
          onClose={handleClosePreguntarModal}
          onSubmit={handleSubmitQuestion}
          tender={selectedTender} // Pasamos el tender seleccionado
        />
      )}
      {/* Modal Paso 1 */}
      {showModal1 && (
        <ModalPostular1
          show={showModal1}
          onClose={handleCloseModal1}
          onNext={handleNextFromModal1}
          tender={selectedTender}
          formData={formData} // Pasa los datos llenados previamente
          setFormData={setFormData} // Pasa el método para actualizar los datos
        />
      )}
      {/* Modal Paso 2 */}
      {showModal2 && (
        <ModalPostular2
          show={showModal2}
          onBack={onBack} // Aquí pasamos el método
          onClose={handleCloseModal2}
          onSubmit={handleSubmitPostulation}
          tender={selectedTender}
          formData={formData} // Pasa los datos llenados previamente
          setFormData={setFormData} // Pasa el método para actualizar los datos
        />
      )}
      <Contacto
        isOpen={showShareModal}
        onClose={() => setShowShareModal(false)}
        id={selectedTender?.id_tender} // ID de la licitación
        titulo={selectedTender?.titulo} // Título de la licitación
      />
    </div>
  );
};

export default InfoLicitaciones;
